var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary btn-raised text-light w-100",on:{"click":function($event){$event.preventDefault();return _vm.onEditClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.dictionary.leftBar.textConfigText))])
}
var staticRenderFns = []

export { render, staticRenderFns }